const TOGGLESHARECOUNT = 'scratch-gui/SHOWSHARECOUNTDOWN';
const CLOSESTOPBUTTON = 'scratch-gui/CLOSESTOPBUTTON';
const VIDEOINFOR = 'scratch-gui/VIDEOINFOR';
const TOGGLEVIDEOMODAL = 'scratch-gui/TOGGLEVIDEOMODAL';
// we are initializing to a blank string instead of an actual title,
// because it would be hard to localize here
const initialState = {
    toggleCount: false,
    closeStopButton: false,
    videoInfor: {},
    closeVideoModal: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case TOGGLESHARECOUNT:
        return Object.assign({}, state, {
            toggleCount: !state.toggleCount
        });
    case CLOSESTOPBUTTON:
        return Object.assign({}, state, {
            closeStopButton: !state.closeStopButton
        });
    case VIDEOINFOR:
        return Object.assign({}, state, {
            videoInfor: action.data
        });
    case TOGGLEVIDEOMODAL:
        return Object.assign({}, state, {
            closeVideoModal: !state.closeVideoModal
        });
    default:
        return state;
    }
};
const toggleCountDown = title => ({
    type: TOGGLESHARECOUNT,
    title: title
});
const toggleCloseButton = close => ({
    type: CLOSESTOPBUTTON,
    title: close
});
const setVideoInfor = data => ({
    type: VIDEOINFOR,
    data: data
});
const toggleVideoModal = data => ({
    type: TOGGLEVIDEOMODAL,
    data: data
});
export {
    reducer as default,
    initialState as showShareCountDowunInitialState,
    toggleCountDown,
    toggleCloseButton,
    setVideoInfor,
    toggleVideoModal
};
